import { formatCicDateTime, getCicDisplayValue } from 'utils/cicReason';

import { COMMENT_CHANGE_PREFIX, COMMENT_UNCHANGED_LABEL } from './CicEditHistoryEntry.constants';

const quote = text => `“${text ?? ''}”`;

export const getEntryDateSuffix = date => ` · ${formatCicDateTime(date)}`;

export const getOriginalDetails = ({ reasonName, comment }) =>
  comment
    ? `${getCicDisplayValue(reasonName)} · ${quote(comment)}`
    : getCicDisplayValue(reasonName);

export const getCommentChangeLabel = ({ isCommentChanged, previousComment, newComment }) =>
  isCommentChanged
    ? `${COMMENT_CHANGE_PREFIX} ${quote(previousComment)} → ${quote(newComment)}`
    : COMMENT_UNCHANGED_LABEL;

export const getNewReasonSuffix = newReasonName => ` → ${getCicDisplayValue(newReasonName)}`;
